import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class GSISContributionSummaryReport extends ReportModelBase {

    constructor(props) {
        super(props);
        this.searchUrl = "api/Reports/createGSISContributionSummaryReport";
        this.title = "GSIS Contribution Summary Report";
        this.exportToExcelUrl = "api/Reports/ExportGSISContributionSummaryReportToExcel";
        this.exportToExcelDataUrl = "api/Reports/createExportGSISContributionSummaryReportToExcel";
        this.exportToPdfUrl = "api/Reports/createGSISContributionSummaryReportToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData.GSISNo}</Table.Cell>
                <Table.Cell>{rowData.EmployeeNo}</Table.Cell>
                <Table.Cell>{rowData.LastName}</Table.Cell>
                <Table.Cell>{rowData.FirstName}</Table.Cell>
                <Table.Cell>{rowData.MInitial}</Table.Cell>
                <Table.Cell>{rowData.GSISEE}</Table.Cell>
                <Table.Cell>{rowData.GSISER}</Table.Cell>
                <Table.Cell>{rowData.TINNumber}</Table.Cell>
                <Table.Cell>{rowData.BirthDate}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>GSIS No</Table.HeaderCell>
                <Table.HeaderCell>Emp No</Table.HeaderCell>
                <Table.HeaderCell>Last Name</Table.HeaderCell>
                <Table.HeaderCell>First Name</Table.HeaderCell>
                <Table.HeaderCell>M. Initial</Table.HeaderCell>
                <Table.HeaderCell>Amount of Loan</Table.HeaderCell>
                <Table.HeaderCell>GSIS ER Contribution</Table.HeaderCell>
                <Table.HeaderCell>TIN Number</Table.HeaderCell>
                <Table.HeaderCell>Birthday</Table.HeaderCell>
            </Table.Row>
        );
    }

}

export default GSISContributionSummaryReport;